
import { Element } from "./element";
import { rem_to_px } from "../px";

/**
 * Renders an x-axis into a chart
 */


class XAxis extends Element {

  renderTick = (ctx, x, label) => {
    const tickLength = rem_to_px(0.5);

    let top = this.top;
    if (label) {
      top = 0.;
    }
    ctx.strokeStyle = "#CCC";
    ctx.beginPath();
    ctx.moveTo(x, top);
    ctx.lineTo(x, this.top + tickLength);
    ctx.stroke();

    if (label) {
      ctx.textAlign = "center";
      ctx.fillStyle = "#000";
      ctx.fillText(label, x, this.top + tickLength * 2.5);
    }

  };

  tickToX = index => {
    return this.graphLeft + index * this.dx;
  };

  calcMaxLabelWidth = (ctx, timeline) => {
    let max_label = "";

    timeline.forEach(item => {
      if (max_label.length < item.label.length) {
        max_label = item.label;
      }
    });

    return ctx.measureText(max_label + "xxxx").width;
  }

  render = (canvas, timeline) => {

    this.updatePos();

    // top line
    const ctx = canvas.getContext("2d");
    ctx.strokeStyle="#000";
    ctx.lineWidth = 1;

    const maxLabelWidth = this.calcMaxLabelWidth(ctx, timeline);
    const maxLabels = Math.floor(this.width() / maxLabelWidth);
    let skip = 0;
    if (timeline.length > maxLabels) {
      skip = Math.ceil(timeline.length / maxLabels);
    }

    ctx.beginPath();
    ctx.moveTo(this.left, this.top);
    ctx.lineTo(this.right, this.top);
    ctx.stroke();

    const sc = 0.9;
    let centerX = (this.right + this.left) / 2.;
    this.graphLeft = (this.left - centerX) * sc + centerX;
    this.dx = (this.right - this.left) / (timeline.length - 1) * sc;

    for(let i=0; i < timeline.length; i++) {

      const label = (skip === 0 || i%skip === 0)
        ? timeline[i].label : null;
      this.renderTick(ctx, this.tickToX(i), label);
    }

  }
}

export { XAxis };
